<template>
    <div class="container content" v-if="activeUser.type == 'admin'">
        <div class="tile is-ancestor">
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <p class="title">{{ $t('message.companies.list.header') }}</p>
                    <div style="float: right; margin-top:35px">
                        <b-button size="is-medium"
                            @click="openAddCompanyModal"
                            icon-left="plus">
                            Lisää uusi yritys
                        </b-button>
                    </div>
                    <b-field label="Yrityshaku">
                    <b-input
                        rounded
                        v-model="search"
                        placeholder="Yrityshaku"
                        icon="magnify"
                        clearable
                        @select="option => selected = option">
                        <template #empty>No results found</template>
                    </b-input>
                </b-field>
                    <b-table
                        paginated
                        per-page="10"
                        @click="openCard"
                        :hoverable="true"
                        :data="filteredCompanies"
                        :columns="columns">
                    </b-table>      
                </article>
            </div>
     
        </div>  
        <b-modal
            v-model="modal"
            has-modal-card
            :can-cancel="true">
            <NewCompanyForm @companyCreated="companyCreated" @closeModal="modal = false"/>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import NewCompanyForm from '@/views/admin/forms/NewCompany'
export default {
    components: {
            NewCompanyForm,
        },
        data() {
            return {
                search: '',
                companies: [],
                modal: false,
                columns: [
                    {
                        field: 'vat',
                        label: 'Y-tunnus'
                    },
                    {
                        field: 'name',
                        label: this.$t('message.companies.list.name')
                    }
                ]
            }
        },
        computed: {
            filteredCompanies() {
                if(this.search == '') {
                    return this.companies;
                }
                let filtered = [];
                this.companies.forEach((company) => {
                    if(company.name.toLowerCase().includes(this.search.toLowerCase())) {
                        filtered.push(company);
                    }
                    if(company.vat.includes(this.search)) {
                        filtered.push(company);
                    }
                });
                return filtered;
            }
        },
        methods: {
            getCompanies() {
                axios.get('/companies').then((response) => {
                    this.companies = response.data;
                })
            },
            companyCreated(datax) {
                this.getCompanies();
                this.modal = false;
                console.log(datax);
            },
            openAddCompanyModal() {
                this.modal = true;
            },
            openCard(data) {
                this.goToWithId('AdminCompany', data.id);
            }
        },
        mounted() {
            this.getCompanies();
        }
    }
</script>

